import { render, staticRenderFns } from "./User.vue?vue&type=template&id=dac36cf4&scoped=true&lang=pug&"
import script from "./scripts/User.js?vue&type=script&lang=js&"
export * from "./scripts/User.js?vue&type=script&lang=js&"
import style0 from "./User.vue?vue&type=style&index=0&id=dac36cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac36cf4",
  null
  
)

export default component.exports